import { PropsWithChildren } from 'react';

import { DataFetcher } from '@provider-portal/common/api/apiFetcher/createFetcher';
import { Spinner } from '@provider-portal/common/components/Spinner';
import {
  GenericError,
  GenericErrorType,
} from '@provider-portal/menu-common/components/GenericError/GenericError';

interface FetcherStateViewProps<Data> {
  fetcher: Omit<DataFetcher<Data>, 'fetch'>;
  stringIds: {
    empty: string;
    error: string;
  };
}

export const FetcherStateView = ({
  fetcher,
  stringIds,
  children,
}: PropsWithChildren<FetcherStateViewProps<unknown>>) => {
  if (fetcher.isFetching) {
    return <Spinner />;
  }
  if (fetcher.error) {
    return <GenericError type={GenericErrorType.error} intlIdTitle={stringIds.error} />;
  }
  if (!fetcher.data) {
    return <GenericError type={GenericErrorType.info} intlIdTitle={stringIds.empty} />;
  }
  return <>{children}</>;
};
